import { FORGOT_PASSWORD } from './index';
import { Action } from '../action';
import { ForgotPasswordForm } from '@shared/core';

export class ForgotPasswordClickSubmitAction implements Action {
	readonly type = FORGOT_PASSWORD.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordClickLoginAction implements Action {
	readonly type = FORGOT_PASSWORD.CLICK_LOGIN;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordClickResendEmailAction implements Action {
	readonly type = FORGOT_PASSWORD.CLICK_RESEND_EMAIL;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordFormUpdateAction implements Action {
	readonly type = FORGOT_PASSWORD.FORM_UPDATE;
	constructor(
		public payload: ForgotPasswordForm,
		public correlationId?: number
	) {}
}

export class ForgotPasswordFormResetAction implements Action {
	readonly type = FORGOT_PASSWORD.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordInitAction implements Action {
	readonly type = FORGOT_PASSWORD.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordInitConfirmationAction implements Action {
	readonly type = FORGOT_PASSWORD.INIT_CONFIRMATION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordDestroyConfirmationAction implements Action {
	readonly type = FORGOT_PASSWORD.DESTROY_CONFIRMATION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ForgotPasswordDestroyAction implements Action {
	readonly type = FORGOT_PASSWORD.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
